import React from 'react';

export default () => (
    <svg className="icon loading-icon" viewBox="0 0 20 20">
        <path d="M10 0C10.4142 0 10.75 0.335786 10.75 0.75C10.75 1.16421 10.4142 1.5 10 1.5C5.30558 1.5 1.5 5.30558 1.5 10C1.5 14.6944 5.30558 18.5 10 18.5C14.6944 18.5 18.5 14.6944 18.5 10C18.5 9.58579 18.8358 9.25 19.25 9.25C19.6642 9.25 20 9.58579 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0Z" />
    </svg>
);
